<template>
  <Modal
    v-model="_value"
    width="500"
    title='短信设置HIK序列号与终端ID'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">

    <Form :label-width="110">
      <FormItem prop="DomainName" label="选择服务器通道">
        <Select v-model="DomainName" style="width: 220px;" @on-change="onChange">
          <Option v-for="item in DomainNameOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="terminalNum" label="主机号/卡号,不满12位前面补“0”">
        <Input v-model="terminalNum" placeholder="门主机号/卡号" style="width: 220px;" @on-change="onChange">
        </Input>
      </FormItem>
      <FormItem prop="terminalNum" label="终端ID">
        <Input v-model="terminationID" placeholder="终端ID" style="width: 220px;" @on-change="onChange">
        </Input>
      </FormItem>
      <FormItem prop="sms" label="短信内容">
        <Input v-model="sms" readonly placeholder="短信内容" style="width: 300px;">
        </Input>
      </FormItem>
    </Form>

  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'setuphikserialnumbersmsmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
    },
    data() {
      return {
        simNum:null,

        //域名选项
        DomainName:null,
        DomainNameOptions: [
          {name: '服务器通道1(JC)', value: 0},
          {name: '服务器通道2(运维)', value: 1},
          {name: '服务器通道3(货运)', value: 2},
          {name: '服务器通道4(两客一危)', value: 3},
          {name: '服务器通道5', value: 4},
          {name: '服务器通道6', value: 5},
        ],
        terminalNum:null,
        terminationID:null,

        sms:null,
      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),
      onChange(){
        this.sms = 'TEL_ID:'+ this.DomainName +',' + this.terminalNum + ',' + this.terminationID + ';A'
      },
      onOk() {
        if (this.DomainName == null || this.DomainName === '') {
          this.$Message.error('请选择服务器通道')
          return
        }
        if (this.terminalNum == null || this.terminalNum === '') {
          this.$Message.error('请检查主机号（卡号）')
          return
        }
          //                     通道                     主机号/卡号              终端ID
          this.sendSMS('TEL_ID:'+ this.DomainName +',' + this.terminalNum + ',' + this.terminationID + ';A')

      },
      sendSMS (content) {
        if (!this.simNum || this.simNum === '') {
          this.$Message.error('请选择SIM卡号')
          return
        }
        store.dispatch('ShortMessageServ_Send', { params: { simNum: this.simNum, content: content } }).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.simNum = this._initValue
          // this.DomainName = 0

          store.dispatch('PositioningDeviceInfoServ_SearchByName',{
            params:{name:this.simNum.substring(6)},
            urlparams:{},
          }).then(res => {
            if (store.getters.get_PositioningDeviceInfo_SearchByNameResult.length >0){
            this.terminalNum = 0 + store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].terminalNum
            this.terminationID = this.terminalNum.substring(5)
            }else {
              this.$Message.error('请检查主机号（卡号）')
            }
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
